import axios from "axios";
import qs from "qs";
import { createBrowserHistory } from "history";
import { getCommonTicketKey, getCommonTicketValue ,getBizJson} from "../utils/utils";
import {
  punishListDataType,
  punishDetailDataType,
  appealListDataType,
  appealDetailDataType,
  supplyType,
  punishDataMoreType,
  spCheckType,
  spGetConfigType,
  getConfigType,
  punishShowMoreType,
  postSubmitType,
  punishType
} from "./interfaceType";

const history = createBrowserHistory();
const commonTicketKey = getCommonTicketKey() || "undefined";
const commonTicketValue = getCommonTicketValue();
const bizjson = getBizJson();
const kv = {
  [commonTicketKey]: commonTicketValue,
  // bizjson: `${bizjson}`,
  // 'testticket':'1'
};
axios.defaults.headers.bizjson=`${bizjson}`
// axios.defaults.baseURL='//10.252.217.178:8008';
// axios.defaults.baseURL='//192.168.199.178:8008';
// axios.defaults.baseURL='//192.168.1.6:8008';

axios.interceptors.response.use(
  (res) => {
    if (res.status >= 200 && res.status < 300) {
      //   if (res.data.code !== 0) {
      //     history.push("/case/home/error");
      //     window.location.reload();
      //   }
      return res.data; //在这里统一拦截结果 把结果处理成res.data
    }
  },
  (err) => {
    try {
      const responseStatus = JSON.parse(JSON.stringify(err)).response.status;
      if (responseStatus >= 403 && responseStatus < 422) {
        history.push("/case/home/404");
        window.location.reload();
      }
    } catch (e) {
      // history.push("/case/home/404");
    }
  }
);

const api = {
  //处罚中心
  PAGE_CONFIG_DATA: "/case/pc/showcfg", //获取处罚申诉配置数据 1
  PUNISH_LIST_DATA: "/case/pc/punish/list", //获取处罚列表数据 1
  PUNISH_DETAIL_DATA: "/case/pc/punish/detail", //获取处罚详情页数据  1
  PUNISH_TYPE_DATA: "/case/pc/punish/list/punishType", //获取处罚筛选数据  1
  PUNISH_SUMMARY: '/merged/punish/summary', // 获取虚拟罚单摘要
  PUNISH_DETAIL: '/merged/punish/detail',// 获取虚拟罚单详情
  NEED_CHALLENGE: '/wlmute/challenge/judge', // 判断是否需要挑战
  CHALLENGE_RESULT: '/wlmute/challenge/report',// 上报挑战结果

  //申诉中心
  APPEAL_LIST_DATA: "/case/pc/list", //获取申诉列表数据 1
  APPEAL_DETAIL_DATA: "/case/pc/detail", //获取申诉详情页数据  1
  REVOKE: "/case/pc/revoke", //撤销申诉
  SUPPLY: "/case/pc/supply", //补充资料提交
  PUNISH_SHOW_MORE_DETAIL: "/case/pc/detail/more", //申诉详情页获取更多数据  暂时无
  //申诉提交
  FETCH_CODE: "/case/pc/create/getcaptcha", //获取验证码 1
  SP_CHECK: "/case/pc/create/spcheck", //非登陆态下用户校验获取用户信息 1
  SP_GET_CONFIG: "/case/pc/create/spgetconfig", //非登陆态下获取模板内容 1
  GET_CONFIG: "/case/pc/create/getconfig", //登陆态下获取模板内容 1
  PUNISH_SHOW_MORE: "/case/pc/create/showmore", //申诉提交获取更多处罚数据    暂时无
  APPEAL_SUBMIT: "/case/pc/create/submit", //申诉提交
  //wos 鉴权
  GET_SIGN: "/case/pc/wos/getSign", // 1
};

//鉴权
export function getSign(params: any) {
  return axios.get(`${api.GET_SIGN}?${qs.stringify(params)}`);
}

//处罚中心
export function fetchPageConfigData(templateId: string) {
  return axios.get(`${api.PAGE_CONFIG_DATA}?templateId=${templateId}`, {
    headers: kv,
  });
}
export function fetchPunishListData(params: punishListDataType) {
  return axios.get(`${api.PUNISH_LIST_DATA}?${qs.stringify(params)}`, {
    headers: kv,
  });
}
export function fetchPunishDetailData(params: punishDetailDataType) {
  return axios.get(`${api.PUNISH_DETAIL_DATA}?${qs.stringify(params)}`, {
    headers: kv,
  });
}
//申诉中心
export function fetchAppealListData(params: appealListDataType) {
  return axios.get(`${api.APPEAL_LIST_DATA}?${qs.stringify(params)}`, {
    headers: kv,
  });
}
export function fetchAppealDetailData(params: appealDetailDataType) {
  return axios.get(`${api.APPEAL_DETAIL_DATA}?${qs.stringify(params)}`, {
    headers: kv,
  });
}
export function revoke(params: { caseId: string; templateId: string }) {
  return axios.post(`${api.REVOKE}?${qs.stringify(params)}`, { headers: kv });
}
export function supply(params: supplyType) {
  return axios.post(`${api.SUPPLY}?${qs.stringify(params)}`, { headers: kv });
}
export function punishShowMoreDetail(params: punishDataMoreType) {
  return axios.get(`${api.PUNISH_SHOW_MORE_DETAIL}?${qs.stringify(params)}`, {
    headers: kv,
  });
}
//申诉提交
export function fetchCode(params: { phone: string }) {
  return axios.get(`${api.FETCH_CODE}?${qs.stringify(params)}`, {
    headers: kv,

  });
  // return axios.post(api.FETCH_CODE, { data: qs.stringify(params)});
}
export function spCheck(params: spCheckType) {
  return axios.get(`${api.SP_CHECK}?${qs.stringify(params)}`, { headers: kv });
  // return axios.post(api.SP_CHECK, { data: qs.stringify(params)});
}
export function spGetConfig(params: spGetConfigType) {
  return axios.get(`${api.SP_GET_CONFIG}?${qs.stringify(params)}`, {
    headers: kv,
  });
}
export function getConfig(params: getConfigType) {
  return axios.get(`${api.GET_CONFIG}?${qs.stringify(params)}`, {
    headers: kv,
  });
}
export function punishShowMore(params: punishShowMoreType) {
  return axios.get(`${api.PUNISH_SHOW_MORE}?${qs.stringify(params)}`, {
    headers: kv,
  });
}
export function postSubmit(params: postSubmitType) {
  return axios.get(`${api.APPEAL_SUBMIT}?${qs.stringify(params)}`, {
    headers: kv,
  });
}
export function fetchPunishTypeData(params: punishType) {
  return axios.get(`${api.PUNISH_TYPE_DATA}?${qs.stringify(params)}`, {
    headers: kv,
  });
}
// 获取微聊禁言罚单
export function getPunishSummary(params: any) {
  return axios.get(`${api.PUNISH_SUMMARY}?${qs.stringify(params)}`, {
    headers: kv,
  })
}
// 获取微聊罚单详情
export function getPunishDetail(params: any) {
  return axios.get(`${api.PUNISH_DETAIL}?${qs.stringify(params)}`, {
    headers: kv,
  })
}
// 判断是否需要挑战
export function needChallenge(params: any) {
  return axios.get(`${api.NEED_CHALLENGE}?${qs.stringify(params)}`, {
    headers: kv,
  })
}
export function challengeResult(params: any) {
  return axios.get(`${api.CHALLENGE_RESULT}?${qs.stringify(params)}`, {
    headers: kv,
  })
}